import "./NewLayout.css";
import ReactDOM from "react-dom";

import {
  Outlet,
  ScrollRestoration,
  useSearchParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NewSidebar from "../pages/sharedPages/NewSidebar/NewSidebar";
import ProfileDropdown from "../pages/sharedPages/ProfileDropdown/ProfileDropdown";
import React, { useEffect, useState } from "react";
import useApi from "../helpers/apiHelper/requestHelper";
import { storeUser } from "../redux/users/usersSlice";
import CustomTutorialModal from "../pages/sharedPages/CommonComponents/TutorialModal/CustomTutorialModal";
import { setRefetchSpecificUser } from "../redux/multicommunity/multicommunity";
import { noLinkSideBarItems } from "../pages/sharedPages/NewSidebar/NoLinkMemberSideBar";
import BubbleSvgButton from "../pages/sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { globalCurrentPageTitle } from "../store/globalstore";
import { useAtom } from "jotai";
import Overlay from "../components/Overlay";
import Notifications from "../pages/sharedPages/Notifications";
import {
  DashboardMarketProvider,
  shouldShowCopyTradeMarketIndicator,
} from "../pages/sharedPages/CommonComponents/DashboardMarketSelect/DashboardMarketContext";
import { toastify } from "../helpers/toast/toastify";
import { setCurrentTab } from "../redux/links/linksSlice";
// const noLinkSideBarItems = [
//   {
//     label: "Dashboard",
//     currentPageTitle: "Dash Board",
//     url: "/cmWithNoLink/dashboard",
//     isDropDown: false,
//     icon: (
//       <svg xmlns="http://www.w3.org/2000/svg" width="24.279" height="23.167">
//         <path
//           d="M24.055 10.453 12.63.235a.32.32 0 0 0-.065-.05.676.676 0 0 0-.914-.014L.225 10.388a.676.676 0 0 0 .899 1.009l2.057-1.843V21.469a1.7 1.7 0 0 0 1.698 1.698h3.606c.879 0 1.593-.714 1.593-1.593v-6.058c0-.135.11-.244.244-.244h3.64c.136 0 .246.11.246.244v6.058c0 .879.714 1.593 1.593 1.593h3.605c.949 0 1.698-.934 1.698-2.128V9.618l2.057 1.843a.676.676 0 0 0 .954-.055.687.687 0 0 0-.06-.953Zm-4.304 3.33v7.246c0 .485-.24.78-.35.78h-3.605a.245.245 0 0 1-.245-.245v-6.048c0-.879-.714-1.593-1.593-1.593h-3.64c-.88 0-1.594.714-1.594 1.593v6.058c0 .135-.11.244-.244.244H4.874a.35.35 0 0 1-.35-.35V8.346l7.581-6.771 7.646 6.836v5.373Z"
//           fillRule="evenodd"
//           data-name="Path 36"
//         />
//       </svg>
//     ),
//   },
// ];

const CmNoLinkLatout = () => {
  const [showTutorialModal, setShowTutorialModal] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isMobileClosing, setIsMobileClosing] = useState(false);
  const [mobileOpenDropdown, setMobileOpenDropdown] = useState(null);
  const api = useApi();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [currentPageTitle, setCurrentPageTitle] = useAtom(
    globalCurrentPageTitle
  );
  const location=useLocation();
  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      // If token is provided in URL, set it in localStorage
      localStorage.setItem("token", token);
    }
    getSpecificUser();
  }, [token]);

  const getSpecificUser = async () => {
    dispatch(setRefetchSpecificUser(true));
    const response = await api("post", "multiCommunity/getSpecificUser", {});
    localStorage.setItem("token", response?.data?.token);

    dispatch(storeUser(response?.data));
    dispatch(setRefetchSpecificUser(false));
    navigate(`/cmWithNoLink/dashboard`);
  };

  // Mobile menu handlers
  const closeMobileMenu = () => {
    setIsMobileClosing(true);
    setIsMobileSidebarOpen(false);
  };

  const handleMobileLinkClick = (path) => {
    setIsMobileSidebarOpen(false);
    setIsMobileClosing(false);
    setMobileOpenDropdown(null);
    navigate(path);
  };

  const handleMobileOverlayAnimationEnd = () => {
    if (isMobileClosing) {
      setIsMobileClosing(false);
    }
  };

  useEffect(() => {
    document.body.style.overflow = (isMobileSidebarOpen || isMobileClosing) ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isMobileSidebarOpen, isMobileClosing]);

  useEffect(() => {
    if (Object.keys(user || {})?.length) {
      setShowTutorialModal(!user?.isWatchTutorial);
    }
  }, [user]);

  const showCopyTradeMarketIndicator = shouldShowCopyTradeMarketIndicator(user);
  const sidebarItems = showCopyTradeMarketIndicator
    ? noLinkSideBarItems.map((item) =>
        item?.url === "/cmWithNoLink/copyTrade2" ||
        item?.label === "Copy Trade Settings"
          ? { ...item, showIndicator: true }
          : item
      )
    : noLinkSideBarItems;

  return (
    <div className="newLayoutBox">
      <div className={`sideBarBox ${showTutorialModal && "z-0"}`}>
        
        <NewSidebar
          items={sidebarItems}
          isOpen={isMobileSidebarOpen}
          onClose={() => setIsMobileSidebarOpen(false)}
        />
      </div>
      <DashboardMarketProvider forceEnable={/\/tradingListening\/?$/.test(location.pathname)}>
      <div className={`mainContentBox `}>
        {(user?.role === "memberNoLink" && location.pathname !== "/cmWithNoLink/marketPlace") && <Overlay />}
        {/* Mobile sticky header */}
        <div className="mobileHeader">
          <div></div>
          <div className="settingProfileBox">
            <div className="mobileDisplay">
              <BubbleSvgButton
                className="createBtnSM"
                onClick={() => navigate("/cmWithNoLink/marketPlace")}
                text={"+"}
                type="button"
                variant="green"
                containerStyling={{ justifyContent: "center" }}
                mainDivStyle={{ width: "auto", height: "auto" }}
              />
              </div>
            <Notifications />
            {/* Should not appear in the mobile header
            {showDashboardMarketSelect && <DashboardMarketSelect />}
            */}
            <button
              className="mobileHamburger"
              onClick={() => setIsMobileSidebarOpen(true)}
              type="button"
            >
              <span></span>
            </button>
          </div>
        </div>

        <div className={`container-fluid g-0`}
          style={(user?.role === "memberNoLink" && location.pathname !== "/cmWithNoLink/marketPlace") ? {
            position: "relative",
            zIndex: 9999,
          } : {}}
        >
          <div className="layoutTitleBox">
            <div className="row g-0">
              <div
                className="d-flex justify-content-md-between justify-content-center flex-md-row flex-column-reverse"
                style={{ gap: 30 }}
              >
                <div className="">
                  <div className="layoutTitleBox__titleRow">
                  <h2 className={`Pagetitle`}>{currentPageTitle}</h2>
                </div>
                </div>
                <div className="settingProfileBox desktopOnly">
                  <div className="d-none d-md-flex">
                    <BubbleSvgButton
                      className="createBtn"
                      onClick={() => {
                        if(location.pathname !== "/cmWithNoLink/marketPlace"){
                          toastify("Subscribe to a group to get started");
                        }
                        navigate("/cmWithNoLink/marketPlace");
                      }}
                      text={"Start"}
                      type="button"
                      variant="green"
                      containerStyling={{
                        justifyContent: "center",
                      }}
                      mainDivStyle={{
                        width: "auto",
                        height: "auto",
                      }}
                    />
                  </div>
                  <div className="d-md-none d-block">
                    <BubbleSvgButton
                      className="createBtnSM"
                      onClick={() => {
                        if(location.pathname !== "/cmWithNoLink/marketPlace"){
                          toastify("Subscribe to a group to get started");
                        }
                        navigate("/cmWithNoLink/marketPlace");
                      }}
                      text={"+"}
                      type="button"
                      variant="green"
                      containerStyling={{
                        justifyContent: "center",
                      }}
                      mainDivStyle={{
                        width: "auto",
                        height: "auto",
                      }}
                    />
                  </div>
                  <Notifications />
                  <ProfileDropdown />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <Outlet />
        <ScrollRestoration />
      </div>
      </DashboardMarketProvider>
      {showTutorialModal && <CustomTutorialModal />}

      {/* ── Mobile overlay portal ── */}
      {(isMobileSidebarOpen || isMobileClosing) && ReactDOM.createPortal(
        <div
          className={`mobile-menu__overlay${isMobileClosing ? " closing" : ""}`}
          onAnimationEnd={handleMobileOverlayAnimationEnd}
        >
          <div className={`dropdown_box${isMobileClosing ? " closing" : ""}`}>
            <button className="mobile-menu__close" onClick={closeMobileMenu}>&times;</button>
            <nav className="mobile-menu__nav">
              {sidebarItems?.map((item, index) => (
                <div key={index}>
                  {!item.isDropDown ? (
                    <button
                      className={`mobile-menu__item${location.pathname === item.url ? " mobile-menu__item--active" : ""}`}
                      onClick={() => {
                        dispatch(setCurrentTab("subscribe"));
                        if (item.currentPageTitle) setCurrentPageTitle(item.currentPageTitle);
                        handleMobileLinkClick(item.url);
                      }}
                    >
                      {item.label}
                      {item.showIndicator && (
                        <span
                          className="mobile-menu__indicator"
                          aria-label="Action needed"
                        />
                      )}
                    </button>
                  ) : (
                    <>
                      <button
                        className="mobile-menu__item mobile-menu__item--dropdown"
                        onClick={() => setMobileOpenDropdown(mobileOpenDropdown === index ? null : index)}
                      >
                        {item.label}
                        <svg
                          className={`mobile-menu__chevron${mobileOpenDropdown === index ? " mobile-menu__chevron--open" : ""}`}
                          viewBox="0 0 10 6" fill="none"
                        >
                          <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                      {mobileOpenDropdown === index && (
                        <div className="mobile-menu__subnav">
                          {item.subItems?.map((subItem, subIndex) => (
                            <button
                              key={subIndex}
                              className="mobile-menu__subitem"
                              onClick={() => {
                                setCurrentPageTitle(subItem.currentPageTitle);
                                handleMobileLinkClick(subItem.url);
                              }}
                            >
                              {subItem.label}
                            </button>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))}
              <button
                className="mobile-menu__item mobile-menu__item--logout"
                onClick={() => handleMobileLinkClick(`/${user?.role}/logout`)}
              >
                LOG OUT
              </button>
            </nav>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default CmNoLinkLatout;
